module.exports = angular
    .module('lipsApp.shared', [ ])
    /*.directive('lipsNavbar', require('./navbar/navbar.directive'))*/
    .directive('focusMe', function($timeout) {
        return {
            scope: { trigger: '@focusMe' },
            link: function(scope, element) {
                scope.$watch('trigger', function(value) {
                    if(value === "true") {
                        $timeout(function() {
                            element[0].focus();
                        });
                    }
                });
            }
        };
    })
    .controller('scrollCtrl', function($scope, $timeout) {
        $scope.scrollTo = function(hash) {
            // Store the currently focused element
            let focusedElement = document.activeElement;

            // Jump to anchor
            window.location.href = '#' + hash;

            // Timeout to let render
            $timeout(function() {
                // Clear focus from any previously focused element to ensure focus from anchor
                if (focusedElement && focusedElement.blur) {
                    focusedElement.blur();
                }
            }, 100);
        }
    })
    .directive('onEscape', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 27) {
                    scope.$apply(function (){
                        scope.$eval(attrs.onEscape);
                    });
                    event.preventDefault();
                }
            });
        };
    })
	.directive('spinner', function($timeout) {
		return {
			scope: { trigger: '@spinner' },
			link: function(scope, element) {
				var html = element[0].innerHTML;
				scope.$watch('trigger', function(value) {
					if(value === "true") {
						$timeout(function() {
							element[0].innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
							element[0].disabled = true;
						});
					}
					else{
						$timeout(function() {
							element[0].innerHTML = html;
							element[0].disabled = false;

						});
					}
				});
			}
		};
	})
    .directive('clickMe', function($timeout) {
        return {
            scope: { trigger: '@clickMe' },
            link: function(scope, element) {
                scope.$watch('trigger', function(value) {
                    if(value === "true") {
                        $timeout(function() {
                            element[0].click();
                        });
                    }
                });
            }
        };
    })
    .directive('onEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.onEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    })
    .directive('magnificPopup',
        [
            "$compile",
            function($compile) {
                return {
                    restrict: 'A',
                    scope: {},
                    link: function($scope, element, attr) {
                        attr.callbacks = {
                            ajaxContentAdded: function() {
                                var content = this.content;

                                var scope =  content.scope();
                                $compile(content)(scope);
                                scope.$digest();
                            }
                        };

                        element.magnificPopup ({
                            delegate: 'a'
                            , type: 'image'
                            , tLoading: 'Loading image #%curr%...'
                            , mainClass: 'mfp-img-mobile'
                            , gallery: {
                                enabled: true
                                , navigateByImgClick: true
                                , preload: [0,1]
                            },
                            image: {
                                tError: 'Viga'
                                , titleSrc: function(item) {
                                    return item.el.attr('title')
                                }
                            }
                        });
                    }
                }
            }
        ]
    )
    .controller('homeController', require('./controllers/home.controller'))
    .controller('welcomeController', require('./controllers/welcome.controller'))
    .controller('headerController', require('./controllers/header.controller'))
    .service('authService', require('./auth/auth.service'))
    .service('sharedService', require('./shared.service'))
    .service('publicObjectsService', require('./services/public-objects.service'))
    .service('publicUsersService', require('./services/public-users.service'))
    .service('classifiersService', require('./services/classifiers.service'))
    .service('roadElementsService', require('./services/road-elements.service'))
    .service('unitsService', require('./services/units.service'))
    .service('componentsService', require('./services/components.service'))
    .service('publicServicesService', require('./services/public-services.service'))
    .service('publicRoutesService', require('./services/public-routes.service'))
    .service('publicRoutesService', require('./services/public-routes.service'))
    .service('accessibilityService', require('./services/accessibility.service'))
    .service('printService', require('./services/print.service'))
    // .service('unitsService', require('../../../private/app/settings/units/units.service'))
    /*.service('commentsService', require('../comments/comments.service'))
    .service('contactsService', require('../contacts/contacts.service'))
    .service('tasksService', require('../tasks/tasks.service'))
    .service('debtsService', require('../debts/debts.service'))
    .service('statusesService', require('../admin/statuses.service'))
    .service('partnercodesService', require('../admin/partnercodes.service'))
    .service('reportsService', require('../reports/reports.service'))
    .filter('addressDisplay', require('./filters/address.filter'))
    .filter('estDateTime', require('./filters/estdatetime.filter'))
    .filter('fullName', require('./filters/fullname.filter'))
    .filter('clientFullName', require('./filters/clientfullname.filter'))
    .filter('translateSex', require('./filters/translateSex.filter'))*/
    .filter('estNumber', require('./filters/estnumber.filter'))
    .filter('estDate', require('./filters/estdate.filter'))
    .filter('text', require('./filters/text.filter'))
    .filter('translateUserRole', require('./filters/translateUserRole.filter'))
    .filter('answer', require('./filters/answer.filter'))
    .filter('addHttp', require('./filters/addHttp.filter'))
    .filter('removeHttpOrHttps', require('./filters/removeHttpOrHttps.filter'))
    .directive('smartFloat', require('./directives/smartfloat.directive.js'))
    .directive('editableText', require('./directives/editableText.directive.js'))
    .directive('uibDatepickerWithIcon', require('./directives/datepicker-with-icon.directive'))
	.directive('resetPassword', require('./directives/reset-password.directive'))
	.directive('objectSearch', require('./directives/object-search.directive'))
	.directive('objectDetails', require('./directives/object-details.directive'))
	.directive('news', require('./directives/news.directive'))
	.directive('mainInfo', require('./directives/main-info.directive'))
	.directive('objectsMainInfo', require('./directives/objects-main-info.directive'))
	.directive('objectResultsMap', require('./directives/object-results-mapview.directive'))
	.directive('objectMap', require('./directives/object-mapview.directive'))
	.directive('objectResultsList', require('./directives/object-results-listview.directive'))
	.directive('objectHomePageSearch', require('./directives/object-home-page-search.directive'))
	.directive('objectSearchFilter', require('./directives/object-search-filter.directive'))
	.directive('autocomplete', require('./directives/autocomplete.directive'))
	.directive('general', require('./directives/object_details_directives/general.directive'))
	.directive('breadcrumbs', require('./directives/breadcrumbs/breadcrumbs.directive'))
	.directive('topObjects', require('./directives/top-objects.directive'))
	.directive('components', require('./directives/object_details_directives/components.directive'))
    .directive('checklistModel', require('./directives/checklist-model.js'))
    .directive('objectAreaModal', require('./directives/object-area-modal.directive'))
    .directive('objectMapModal', require('./directives/object-map-modal.directive'))
    .directive('roadElementDataModal', require('./directives/road_elements/road-element-data-modal.directive'))
    .directive('roadElementSearch', require('./directives/road_elements/road-element-search.directive'))
    .directive('roadElementsMap', require('./directives/road_elements/road-elements-map.directive'))
    .directive('objectComponentView', require('./directives/object-component-view.directive'))
    .directive('selectRegion', require('./directives/select-region.directive'))
    .directive('panel', require('./directives/panel.directive'))
    .directive('systemIcon', require('./directives/systemIcon.directive'))
    .directive('currentUserBookmarks', require('./directives/bookmarks/current-user-bookmarks.directive'))
    .directive('userProfile', require('./directives/user-profile.directive'))
    .directive('icheck', require('./directives/icheck.directive'))
    .directive('navBar', require('./navbar/navbar.directive'))
    .directive('serviceSearch', require('./directives/services/service-search.directive'))
    .directive('serviceSearchFilter', require('./directives/services/search_directives/service-search-filter.directive'))
    .directive('serviceResultsList', require('./directives/services/search_directives/service-results-listview.directive'))
    .directive('serviceDetails', require('./directives/services/view/service-details.directive'))
    .directive('routeSearch', require('./directives/routes/route-search.directive'))
    .directive('routeResultsMap', require('./directives/routes/search_directives/route-results-mapview.directive'))
    .directive('routeDataModal', require('./directives/routes/search_directives/route-data-modal.directive'))
    .directive('routeDetails', require('./directives/routes/route_details_directives/route-details.directive'))
    .directive('routeViewMap', require('./directives/routes/route-view-map.directive'))
    .directive('bookmarksMap', require('./directives/bookmarks/bookmarks-map.directive'))
    .directive('objectEdit', require('./directives/objects/edit/object-edit.directive'))
    .directive('objectEditMain', require('./directives/objects/edit/directives/objects-edit-main.directive'))
    .directive('objectEditAccessibilities', require('./directives/objects/edit/directives/objects-edit-accessibilities.directive'))
    .directive('objectEditDescription', require('./directives/objects/edit/directives/objects-edit-description.directive'))
    .directive('objectEditFeatures', require('./directives/objects/edit/directives/objects-edit-features.directive'))
    .directive('objectEditImageFiles', require('./directives/objects/edit/directives/objects-edit-image-files.directive'))
    .directive('objectEditImageFilesModal', require('./directives/objects/edit/directives/objects-edit-image-files-modal.directive'))
    .directive('publicDataEntry', require('./directives/objects/public-data-entry.directive'))
    .directive('accessibility', require('./directives/accesssibility/accessibility.directive'))
    .directive('fillComponentSurveys', require('./directives/objects/fill_component_surveys/surveys-fill.directive'))
    .directive('surveyQuestionImageFilesModal', require('./directives/objects/fill_component_surveys/modal/survey-question-image-files-modal.directive'))
    .directive('articlesList', require('./directives/accesssibility/directives/articles-list.directive'))
    .directive('articleDetails', require('./directives/accesssibility/view/article-details.directive'))
    .directive('linksList', require('./directives/accesssibility/directives/links-list.directive'))
    .directive('functionality', require('./directives/accesssibility/directives/functionality.directive'))
    .directive('imageModal', require('./directives/image-modal.directive'))
    .directive('objectImages', require('./directives/object-images.directive'))
    .directive('errorMessageModal', require('./directives/error-message-modal.directive'))
    .directive('successMessageModal', require('./directives/success-message-modal.directive'))
    .directive('api', require('./directives/api/api.directive'))
    .directive('infoBox', require('./directives/info-box.directive'))
    .directive('focusModal', require('./directives/modal/focus-modal.directive'))
    .directive('preventScroll', require('./directives/prevent-scroll.directive'))
    .config(require('./shared.config'))
    // .controller('HomeController', require('./controllers/home.controller'))
    .run(function($rootScope, authService, $timeout, $uibModal, $uibModalStack) {

    	if(window.viewOptions) {
			$rootScope.currentUser = $.extend({}, window.viewOptions.currentUser);
		}

		$rootScope.baseUrl = BASE_URL;
		$rootScope.resourcesBaseUrl = RESOURCES_BASE_URL;

		$rootScope.mapUrls = mapUrls;

    	var urlWithoutLastSlash = BASE_URL.slice(0, -1);
		$rootScope.rootUrl =  urlWithoutLastSlash.slice(0, urlWithoutLastSlash.lastIndexOf('/')) + '/';

		$rootScope.isModalOpen = false;

        $rootScope.tinymceOptions = {
            setup: function(editor) {
                //Focus the editor on load
                $timeout(function(){ editor.focus(); },500);
            },
            menubar:false,
            statusbar: false
        };

        $rootScope.logIn = function (startLogin) {
            $rootScope.closeMinimalizedModal();

            if (!$rootScope.isModalOpen) {
                $rootScope.isModalOpen = true;

                $uibModal.open({
                    template: require('./directives/login-modal.html'),
                    controller: require('./directives/login-modal.controller'),
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'center-modal',
                    resolve: {
                        onLogin () {
                            return $rootScope.setLoggedIn;
                        },
                        startLogin () {
                            return startLogin;
                        }
                    }
                });
            }
        };

		$rootScope.userProfile = function () {
			$rootScope.userProfileModalOpened = true;
            $rootScope.isModalOpen = true;
		};

        $rootScope.setLoggedIn = function () {
            $rootScope.loggedIn = true;
        };

        $rootScope.openSuggestionModal = function () {
            $rootScope.closeMinimalizedModal();
            $uibModal.open({
                template: require('./directives/suggestions/general-suggestion-modal.directive.html'),
                controller: require('./directives/suggestions/general-suggestion-modal.directive'),
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'center-modal'

            });
        };
        $rootScope.logOut = function () {
            authService.logout();
        };

        $rootScope.getUserName = function () {
            return $rootScope.currentUser.firstname + ' ' + $rootScope.currentUser.lastname;
        };

		$rootScope.getCurrentUser = function () {
			return $.extend({}, $rootScope.currentUser);
		};

        $rootScope.openModal = () => {
            $uibModal.open({
                template: require('./modal/modal.html'),
                controller: require('./modal/modal.controller.js'),
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'center-modal',
                resolve: {
                }
            });
        };


        $rootScope.closeMinimalizedModal = () => {
            if (angular.element('body').hasClass('modal_minimize')) {
                $uibModalStack.dismissAll();
                $rootScope.isModalOpen = false;
                angular.element('body').removeClass('modal_minimize');
            }
        };

        $rootScope.openAkisOpisModal = (content) => {
            $uibModal.open({
                template: require('./directives/road_elements/akis-opis-modal.directive.html'),
                controller: require('./directives/road_elements/akis-opis-modal.directive'),
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'center-modal',
                resolve: {
                    data () {
                        return content;
                    }
                }
            });
            $rootScope.isModalOpen = true;
        };
    });



/** WEBPACK FOOTER **
 ** ./app/shared/shared.module.js
 **/